import { useCallback } from 'react';
import { ETestIds } from 'shared/constants/testIds';
import { TMapOffersResult } from 'shared/types/common/offer';
import { getOffersCount } from 'shared/utils/offers/flattenOffersList';
import { useTracking } from 'shared/utils/tracking/useTracking';

export const useScrollToOffers = (offersList: TMapOffersResult) => {
  const { trackMobileShowButtonAmountOffers } = useTracking();
  const offersCount = getOffersCount(offersList);

  return useCallback(() => {
    const offersListing = document.querySelector(`[data-testid=${ETestIds.OffersListing}]`);
    offersListing?.scrollIntoView({
      behavior: 'smooth',
    });
    trackMobileShowButtonAmountOffers(offersCount);
  }, [offersCount, trackMobileShowButtonAmountOffers]);
};
